import styled from 'styled-components';

export const Container = styled.section`
  display: flex;
  flex-direction: row;

  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;

  @media only screen and (max-width: 1000px) {
    flex-direction: column;
  }
`;

export const Content = styled.div`
  width: 490px;
  margin-top: 33px;
  color: #272727;

  h1 {
    font-weight: 900;
    font-size: 37.5px;
    line-height: 60px;
  }

  p {
    font-size: 15px;
    line-height: 22px;
    text-align: justify;

    margin-top: 20px;

    color: #000000;
    max-width: 450px;
  }

  span {
    color: #199ec6;
  }

  @media only screen and (max-width: 1000px) {
    width: auto;

    align-self: center;
    text-align: center;

    h1 {
      font-size: min(6.5vw, 37.5px);
      line-height: min(10vw, 60px);
    }

    p {
      font-size: min(4vw, 15px);
      line-height: min(5vw, 22px);
    }
  }
`;

// ---> Start About Image <---

export const AboutImageContainer = styled.div`
  position: relative;

  display: flex;
  flex: 1;
  justify-content: center;

  margin-top: 25px;
`;

export const AboutImageContent = styled.div`
  transform: translate(50px, 100px);

  img {
    width: 40vw;
    max-width: 480px;
    filter: drop-shadow(6px 7px 6px rgba(0, 0, 0, 0.28));
  }

  @media only screen and (max-width: 1000px) {
    transform: translate(0px, 0px);

    img {
      width: 90vw;
    }
  }
`;

export const BlueBackground = styled.div`
  z-index: -1;
  position: absolute;
  left: 0;

  background-color: #199ec6;

  top: 25px;

  width: 100vw;
  height: 335px;

  transform: translate(-15px, 0px);

  div {
    position: absolute;
    bottom: 0;
    left: 15px;

    h1 {
      font-weight: bold;
      font-size: 50px;
      line-height: 75px;

      color: #ffffff;
    }
  }

  @media only screen and (max-width: 1000px) {
    transform: translate(-20px, 0px);
    height: 56vw;
    max-height: 310px;

    div {
      display: none;
    }
  }
`;

// ---> End About Image <---

export const SectionTitle = styled.div`
  span {
    font-weight: 900;
    font-size: 20px;

    color: #7d7d7d;
  }

  @media only screen and (max-width: 1000px) {
    span {
      font-size: min(4.5vw, 20px);
      line-height: 35px;
    }
  }
`;

export const LearnMore = styled.div`
  margin-top: 20px;

  a {
    font-weight: bold;
    font-size: 18px;
    line-height: 27px;
    text-decoration: none;
    transition: color 0.2s;

    color: #272727;

    :hover {
      color: #386882;
    }
  }

  @media only screen and (max-width: 1000px) {
    a {
      font-size: min(4.5vw, 18px);
    }
  }
`;
